export default __webpack_public_path__ + "static/media/youshou.a1c63d82.jpg";